"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiButtonRedirect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MuiButton = _interopRequireDefault(require("../MuiButton/MuiButton"));

var _customProps = require("../../utils/customProps");

var _appRedirect = _interopRequireDefault(require("../../utils/appRedirect"));

/**
 * MuiButtonRedirect onClick will redirect you to a new route in the current App
 * More docs and demos at https://material-ui.com/api/button/
 * cant redirect in docs
 */
var MuiButtonRedirect = function MuiButtonRedirect(_ref) {
  var redirectRoute = _ref.redirectRoute,
      button = _ref.button;

  var onClick = function onClick() {
    return (0, _appRedirect.default)(redirectRoute);
  };

  var muibutton = button[0];
  return /*#__PURE__*/_react.default.createElement(_MuiButton.default, (0, _extends2.default)({}, muibutton, {
    onClick: onClick
  }));
};

exports.MuiButtonRedirect = MuiButtonRedirect;
var _default = MuiButtonRedirect;
exports.default = _default;
MuiButtonRedirect.propTypes = {
  /** MuiButton Allowed maximum: 1 */
  button: function button(props, propName, componentName) {
    var components = ['MuiButton'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** redirect route */
  redirectRoute: _propTypes.default.string.isRequired
};
MuiButtonRedirect.defaultProps = {
  button: []
};